import { render } from "./CreateAnnotationSetModal.vue?vue&type=template&id=a468ad9a&scoped=true"
import script from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"
export * from "./CreateAnnotationSetModal.vue?vue&type=script&lang=js"

import "./CreateAnnotationSetModal.vue?vue&type=style&index=0&id=a468ad9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a468ad9a"]])

export default __exports__